import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ConfirmationCard from '../../components/Shared/ConfirmationCardMultiActionsCard';
import TitleComponent from '../../components/Shared/TitleMultiActionsCard';
import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

import { copyFor } from '../../copy/copy';

const RecordAction = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            thankYouText={props.thankYouText}
            titleComponent={<TitleComponent thankYouTitle={props.thankYouTitle} />}
            {...props}
        />
    </TransitionContainerNoExit>
);

RecordAction.propTypes = {
    thankYouText: PropTypes.string.isRequired,
    thankYouTitle: PropTypes.string
};

export default connect((state, props) => {
    const isEmailAction = state.widget.activeAction.representativeSearch;
    return {
        thankYouText:
            props.thankYouText || copyFor('thankYou', 'description', 'recordvideo'),
        thankYouTitle:
            props.thankYouTitle || isEmailAction
                ? copyFor('thankYou', 'title', 'recordvideo')
                : copyFor('postRecord', 'description', 'recordvideo')
    };
}, {})(RecordAction);
